import React from "react";
import { ListItemIcon, ListItemButton, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GetIconByType } from '../icon/index'

const ListLink = ({ iconType, label, to }) => {
    const navigate = useNavigate();

    return (
        <ListItemButton onClick={() => navigate(to)}>
            <ListItemIcon>
                {GetIconByType(iconType)}
            </ListItemIcon>
            <ListItemText primary={label} />
        </ListItemButton>
    );
};

export default ListLink;